import { ReferenceField, ReferenceFieldProps, TextField, TextFieldProps, FunctionField } from 'react-admin';
import ApplicationForm from '../GeneratedModels/ApplicationForm';

/**
 * Generated by Db2Ts @ 2023-06-12 15:11:1148
 */

interface ApplicationFormTextFieldProps extends Omit<TextFieldProps, "source"> {
  source: 'id' | 'created' | 'createdBy' | 'updated' | 'updatedBy',
}

interface ApplicationFormReferenceFieldProps extends Omit<ReferenceFieldProps, 'children' | 'source' | 'reference'> {
  source?: string,
  reference?: string,
  textFieldProps?: ApplicationFormTextFieldProps
  render?: (record: ApplicationForm) => string,
}

const ApplicationFormReferenceField = ({ source, reference, render, textFieldProps, ...rest }: ApplicationFormReferenceFieldProps) => {
  return (
    <ReferenceField {...rest} source={source ?? 'application_form_id'} reference={reference ?? 'application_form'}>
      {render
        ? <FunctionField render={render} />
        : <TextField {...textFieldProps} />
      }
    </ReferenceField>
  )
}

ApplicationFormReferenceField.defaultProps = {
  addLabel: true,
  // label: "ApplicationForm",
  source: "application_form_id",
  reference: "application_form",
  textFieldProps: {
    source: 'id',
  },
};

export default ApplicationFormReferenceField;
